var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lock-screen-btn-con",on:{"click":_vm.lock}},[_c('Tooltip',{attrs:{"content":"锁定屏幕","placement":"bottom"}},[_c('Icon',{attrs:{"type":"ios-lock","size":30}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }